import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { Button, InputLabel, MenuItem, Select, SelectChangeEvent, Stack } from "@mui/material";
import { forwardRef, useEffect, useState } from "react";
import Modal, { CommonModalProps } from "..";
import { ingestService } from "../../../Core/Api/services";
import { ProviderNewAssignmentDto } from "../../../Core/Api/Types/db-lab-provider-infos";
import useCustomSnackbar from "../../../Utils/Hooks/useCustomSnackbar";
import { useTranslation } from "react-i18next";

export type ModalNewAssignmentElementProps = {
  assetId: number;
  assetProviderId: number;
  availableProviders?: ProviderNewAssignmentDto[];
};

export type ModalNewAssignmentProps = CommonModalProps<ModalNewAssignmentElementProps>;

const ModalNewAssignment = forwardRef<any, ModalNewAssignmentProps>((props, ref) => {
  const { t } = useTranslation();
  const { assetId, assetProviderId, availableProviders, closeModal } = props;
  const [selectedProviderId, setSelectedProviderId] = useState(assetProviderId);
  const [fetchedProviders, setFetchedProviders] = useState<ProviderNewAssignmentDto[]>([]);

  const enqueueSnackbar = useCustomSnackbar();

  const handleNewAssignment = () => {
    ingestService.AssignRequestToProvider(assetId, selectedProviderId).then((response) => {
      if (response.success) {
        enqueueSnackbar(t("alert:success.newProviderAssigned"), "success");
        closeModal();
      } else enqueueSnackbar(response.message || t("alert:error.somethingWentWrong"), "error");
    });
  };

  const handleCancelClick = () => {
    closeModal();
  };

  useEffect(() => {
    if (availableProviders) setFetchedProviders(availableProviders);
    else
      ingestService.GetNewAssignmentProviders().then((providers) => {
        setFetchedProviders(providers);
      });
  }, []);

  return (
    <Modal
      reference={ref}
      title={t("modal:title.assignNewProvider")}
      closeModal={handleCancelClick}
      width={500}
      footer={
        <Stack direction="row" justifyContent="space-between">
          <Button variant="outlined" onClick={handleCancelClick}>
            {t("common:cancel")}
          </Button>
          <Button variant="outlined" color="success" onClick={handleNewAssignment}>
            {t("common:confirm")}
          </Button>
        </Stack>
      }
    >
      <Stack spacing={1}>
        <InputLabel htmlFor="select-language">{t("field:label.selectTheProvider")}</InputLabel>
        <Select
          id="select-language"
          IconComponent={ExpandMoreRoundedIcon}
          sx={{ mb: 1 }}
          MenuProps={{ PaperProps: { sx: { maxHeight: 400 } } }}
          value={selectedProviderId}
          onChange={(event: SelectChangeEvent<number>) => setSelectedProviderId(Number(event.target.value))}
        >
          {fetchedProviders.map((provider) => (
            <MenuItem key={provider.id} value={provider.id}>
              {provider.name}
            </MenuItem>
          ))}
        </Select>
      </Stack>
    </Modal>
  );
});

export default ModalNewAssignment;
